import { createIcon } from './createIcon'

export const AirShipmentsIcon = createIcon({
  displayName: 'Air',
  viewBox: '0 0 23 15',
  path: [
    <path
      fill="currentColor"
      d="M20.454.2a3.172 3.172 0 00-2.485.477L14.445 3.09a.546.546 0 01-.405 0L5.917.078a1.515 1.515 0 00-1.392.211c-.624.41-1.213.87-1.763 1.374a1.515 1.515 0 00.194 2.256L7.68 6.756a.423.423 0 01.211.352.44.44 0 01-.211.335L5.917 8.694a.423.423 0 01-.476 0L3.414 7.496a1.322 1.322 0 00-1.356.212C.578 8.94.418 9.064.295 9.205a1.357 1.357 0 00.335 1.992s-.282-.177 5.075 3.524a1.762 1.762 0 001.92 0l13.834-8.6A3.313 3.313 0 0020.436.096l.018.106z"
    />,
  ],
})
